import { render, staticRenderFns } from "./ExtratoInfracao.vue?vue&type=template&id=38c34ef0"
import script from "./ExtratoInfracao.vue?vue&type=script&lang=js"
export * from "./ExtratoInfracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports